import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminUserP2P(userId, { page = 1, limit = 20, status, refresh } = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (status && status !== "all") params.set("status", status);
  if (refresh) params.set("refresh", "1");

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/users/${userId}/p2p?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
